import { CIcon } from '~/icons/types'
export const ciXyma: CIcon = {
  name: 'xyma',
  type: 'brand',
  width: 1328,
  height: 773,
  paths: [
    {
      opacity: '.93',
      d: 'M1151.12 0h5.83c-1.66 1.88-4.45 1.87-6.19.13l.36-.13Z',
      fill: '#c75e9c'
    },
    {
      d:
        'M1156.95 0h21.15c1.65 1.85 4.42 1.8 6.27.2 18.37 1.34 36.8 4.07 54.25 10.23 16.64 5.77 32.38 14.55 45.29 26.62 13.21 12.12 23.27 27.44 30.08 43.97 8.73 21.11 12.52 43.94 13.67 66.64-.96 1.37-1.11 2.8-.43 4.32-.73 10.3.02 20.67-.23 31 .01 56.67 0 113.33 0 169.99-.12 19.64.22 39.28-.13 58.9-28.95.32-57.9 0-86.85.16-3.87.12-7.9-.6-11.6.83-.03-12.68 0-25.36-.02-38.04-24.89 21.37-56.18 36.31-89.25 38.07-.19-29.97-.19-59.96-.01-89.93 9.42.75 19.02.88 28.25-1.41 20.8-4.82 38.94-17.3 54.16-31.9 1.73-1.88 3.95-3.43 5.24-5.66.18-15.98.01-31.97.08-47.95-22.6-1.29-45.39-1.93-67.87 1.15-6.73 1.07-13.42 2.49-19.85 4.75-.19-29.34-.18-58.68-.01-88.02 28.93-4.89 58.6-5.97 87.7-1.95.46-11.25-.09-23.11-5.66-33.18-6.92-12.96-20.51-20.8-34.23-24.76-7.63-2.4-15.6-3.13-23.49-4.12-4-1.53-8.31-.81-12.47-.96-2.84-.12-5.66.12-8.36.97-3.02.17-6.01.57-9 .92l-.41-.55c-4.22-12.61-9.95-24.8-17.96-35.47-11.48-15.75-27.37-28.08-45.19-35.87l-1.06-.51 1.17.34c25.35-11.34 52.93-17.09 80.58-18.65 1.74 1.74 4.53 1.75 6.19-.13Z',
      fill: '#cd3c92'
    },
    {
      d:
        'M996.87 277.69c2.37-31.22 18.24-60.83 42.14-80.91.25 33.73.04 67.47.11 101.2-.14 28.83.27 57.67-.21 86.49-.44-.27-1.33-.83-1.78-1.11-23.51-18.51-37.73-47.49-40.25-77.09.37-4.78-.49-9.52-.48-14.29-.06-4.78.87-9.52.47-14.29Z',
      fill: '#cd3c92'
    },
    {
      opacity: '.89',
      d: 'M1178.1 0h5.89l.38.2c-1.85 1.6-4.62 1.65-6.27-.2Z',
      fill: '#c05e98'
    },
    {
      d:
        'M746.48 14.59c17.59-5.63 36.27-6.44 54.6-5.56 35.93 2.79 68.73 24.43 88.48 54.1 13.17-11.83 26.82-23.28 42.06-32.38 14.87-8.99 31.26-15.5 48.34-18.76 13.83-2.81 27.97-3.4 42.04-3.19 16.08.12 32.22 3.28 47.01 9.64l1.06.51c-16.49 7.56-32.17 16.9-46.5 28.03 10.11 27.41 19.93 54.93 30.32 82.23 12.33-10.84 25.56-20.86 40.45-27.92 12.2-5.91 25.47-9.48 38.95-10.79 3.76 12.15 5.83 24.85 5.87 37.57.1 8.61.13 17.24-.02 25.85-36.03 6.24-71.86 19.05-100.13 42.86-.01-15.27.02-30.54 0-45.81-.69-12.02-2.82-24.66-10.36-34.45-6.43-8.57-17.1-13.1-27.63-13.57-15.88-.63-31.33 4.66-45.4 11.59-16.75 8.43-32.31 19.61-44.62 33.83 0 88.21.01 176.42 0 264.62H811c-.01-76.65 0-153.3 0-229.95-.07-14.49.45-29.04-1.43-43.43-1.49-9.84-4.7-20.04-12.17-27.01-6.71-6.57-16.25-9.09-25.39-9.62-13.89-.56-27.66 3.54-39.71 10.29-16.65 9.29-30.57 22.64-43.33 36.64 0 87.69.01 175.38-.01 263.07-28.87.02-57.74.03-86.61 0 15.9-42.85 32.18-85.56 48.22-128.36 12.69-34.01 25.79-67.87 38.21-101.97-33.94.5-67.88 1.1-101.82 1.62.11-56.57.01-113.13.05-169.69 33.98-.03 67.97-.08 101.95.02.03 11.27-.01 22.55.02 33.82 17.13-14.28 35.98-27.23 57.5-33.83Z',
      fill: '#f2e006'
    },
    {
      d:
        'M1110.87 262.81c6.15-10.35 16.86-17.52 28.28-20.87.13 27 .13 54.01-.01 81.02-8.82-.71-17.84-3.6-24.47-9.65-5.71-5.2-8.75-12.76-9.52-20.33-1.03-10.3.4-21.14 5.72-30.17Z',
      fill: '#f2e006'
    },
    {
      d:
        'M1040.08 385.45c19.69 15.18 44.22 22.78 68.65 25.76-2.17.78-4.41 1.26-6.7 1.11-20.67-.27-41.37.34-62.02-.3-.48-8.84-.41-17.74.07-26.57Z',
      fill: '#f2e006'
    },
    {
      d:
        'M1070.07 18.95c17.82 7.79 33.71 20.12 45.19 35.87 8.01 10.67 13.74 22.86 17.96 35.47l.07.21c-13.48 1.31-26.75 4.88-38.95 10.79-14.89 7.06-28.12 17.08-40.45 27.92-10.39-27.3-20.21-54.82-30.32-82.23 14.33-11.13 30.01-20.47 46.5-28.03Z',
      fill: '#c33503'
    },
    {
      d:
        'M1039.01 196.78c28.27-23.81 64.1-36.62 100.13-42.86-.17 29.34-.18 58.68.01 88.02-11.42 3.35-22.13 10.52-28.28 20.87-5.32 9.03-6.75 19.87-5.72 30.17.77 7.57 3.81 15.13 9.52 20.33 6.63 6.05 15.65 8.94 24.47 9.65-.18 29.97-.18 59.96.01 89.93-10.1-.77-20.33-.38-30.42-1.68-24.43-2.98-48.96-10.58-68.65-25.76-.4-.34-.79-.66-1.17-.98.48-28.82.07-57.66.21-86.49-.07-33.73.14-67.47-.11-101.2Z',
      fill: '#c33503'
    },
    {
      opacity: '.96',
      d:
        'M1142.63 89.92c2.7-.85 5.52-1.09 8.36-.97 4.16.15 8.47-.57 12.47.96-6.94.13-13.89.13-20.83.01Z',
      fill: '#cb579c'
    },
    {
      opacity: '.78',
      d: 'm1327.66 147.66.34.39v3.72l-.77.21c-.68-1.52-.53-2.95.43-4.32Z',
      fill: '#ae6590'
    },
    {
      opacity: '.97',
      d:
        'm1327.23 151.98.77-.21v261.21c-33.19-.05-66.4.2-99.58-.12 3.7-1.43 7.73-.71 11.6-.83 28.95-.16 57.9.16 86.85-.16.35-19.62.01-39.26.13-58.9 0-56.66.01-113.32 0-169.99.25-10.33-.5-20.7.23-31Z',
      fill: '#d060a2'
    },
    {
      d:
        'M.51 176.6c39.45-.09 78.89-.11 118.34.01 26.2 38 52.19 76.16 78.47 114.11 26.18-38.13 52.21-76.38 78.65-114.32 1.01 3.68 2.55 7.18 3.9 10.74 12.64 32.87 25.44 65.68 37.99 98.58.25.78.51 1.56.76 2.35-.22-.42-.66-1.25-.88-1.67-14.04 20.34-27.89 40.82-42.11 61.03l-.08.1-.07.12c-6.38 9.84-13.38 19.28-19.78 29.11 44.52 65.39 88.84 130.93 133.3 196.37-38.93.08-77.85.04-116.78.02-4.29-6.13-8.61-12.24-12.69-18.51l-.08-.12-.07-.1c-3.1-4.15-6-8.43-8.83-12.76-.05-.07-.14-.2-.18-.26-3.73-5.17-7.4-10.4-10.84-15.76l-.08-.12-.08-.09c-6.77-9.41-13.25-19.03-19.81-28.59l-.33-.49c-2.95-4.13-5.82-8.32-8.66-12.53-.09-.13-.26-.38-.35-.5-4.66-6.62-9.24-13.3-13.8-19.99-8.23 11.98-16.34 24.04-24.62 35.99-.09.12-.26.37-.35.5-9.89 14.56-19.72 29.18-29.83 43.6l-.07.1-.08.12c-4.13 6.35-8.38 12.64-12.83 18.78l-.09.11-.08.13c-2.12 3.57-4.66 6.87-6.84 10.41-39.29.22-78.58.06-117.87.07 44.78-65.5 89.5-131.05 134.25-196.58-6.25-8.91-12.47-17.85-18.48-26.92l-.08-.12-.08-.11c-.46-.69-1.39-2.06-1.85-2.75l-.08-.12-.08-.11c-3.14-4.12-6.03-8.43-8.83-12.79l-.08-.12-.07-.09a331.77 331.77 0 0 1-10.86-15.78l-.07-.12-.08-.1c-3.1-4.16-6.01-8.45-8.84-12.8l-.07-.12-.07-.1c-.47-.69-1.4-2.07-1.86-2.76l-.08-.12-.08-.1c-10.45-14.8-20.7-29.76-30.83-44.78-.05-.06-.13-.18-.17-.24-10.43-14.76-20.56-29.73-30.8-44.62-.08-.12-.25-.37-.34-.49-3.6-5.2-7.27-10.35-10.7-15.66l-.07-.12-.08-.1c-4.4-6.19-8.81-12.39-12.87-18.82Z',
      fill: '#d04227'
    },
    {
      d:
        'M275.97 176.4c38.85.15 77.7 0 116.55.08-.43 1.44-1.18 2.77-2.06 3.99-24.28 35.02-48.21 70.29-72.6 105.25-12.55-32.9-25.35-65.71-37.99-98.58-1.35-3.56-2.89-7.06-3.9-10.74Z',
      fill: '#33181a'
    },
    {
      d:
        'm392.52 176.48.54.02c.66 1.51 1.22 3.07 1.77 4.64 30.81 87.23 61.82 174.4 92.57 261.66 18.43-47.73 36.75-95.49 55.14-143.23 14.84-38.34 29.36-76.82 44.42-115.07.36 76.12.03 152.25.16 228.37 5.07.11 10.14-.17 15.2.2-12.34 33.59-25.18 66.99-37.7 100.51-14.74 38.47-27.9 77.69-46.81 114.4-18.49 36.32-42.11 70.86-73.96 96.76-32.7 27.03-73.73 42.95-115.68 47.92-8.31-28.8-16.49-57.64-24.49-86.52 14.15-3.29 28.34-6.86 41.7-12.69 16.48-6.92 31.71-16.84 44.39-29.44 1.73.22 2.46-.53 2.18-2.25 17.21-18.14 28.98-40.59 38.74-63.4-37.41-96.75-74.76-193.51-112.07-290.29-.25-.79-.51-1.57-.76-2.35 24.39-34.96 48.32-70.23 72.6-105.25.88-1.22 1.63-2.55 2.06-3.99Z',
      fill: '#3e5ca8'
    },
    {
      d: 'M1296.76 550.74a4.55 4.55 0 0 1 2-2c.43 1.8-.23 2.47-2 2Z',
      fill: '#3e5ca8'
    },
    {
      d:
        'M586.96 184.27c33.94-.52 67.88-1.12 101.82-1.62-12.42 34.1-25.52 67.96-38.21 101.97-16.04 42.8-32.32 85.51-48.22 128.36l-.03.09c-5.06-.37-10.13-.09-15.2-.2-.13-76.12.2-152.25-.16-228.37v-.23Z',
      fill: '#3b5104'
    },
    {
      opacity: '.68',
      d: 'm13.38 195.42.08.1.07.12c-.03-.06-.11-.17-.15-.22Z',
      fill: '#985b50'
    },
    { opacity: '.66', d: 'M24.23 211.3Z', fill: '#955a4e' },
    {
      opacity: '.66',
      d: 'm88.39 304.41.07.1.07.12c-.03-.05-.11-.16-.14-.22Z',
      fill: '#955a4e'
    },
    { opacity: '.7', d: 'M55.37 256.41Z', fill: '#9d5c50' },
    {
      opacity: '.7',
      d: 'M210.22 483.32c.09.12.26.37.35.5-.09-.13-.26-.38-.35-.5Z',
      fill: '#9d5c50'
    },
    {
      opacity: '.7',
      d: 'm259.38 554.42.07.1.08.12c-.04-.05-.12-.16-.15-.22Z',
      fill: '#9d5c50'
    },
    {
      opacity: '.71',
      d:
        'M996 292.03c.05-4.79-.38-9.66.87-14.34.4 4.77-.53 9.51-.47 14.29-.01 4.77.85 9.51.48 14.29-1.18-4.66-.87-9.48-.88-14.24Z',
      fill: '#9f5f85'
    },
    {
      opacity: '.73',
      d: 'm86.37 301.43.08.1.08.12c-.04-.06-.12-.17-.16-.22Z',
      fill: '#a35f52'
    },
    {
      opacity: '.73',
      d: 'M171.45 499.82c.09-.13.26-.38.35-.5-.09.12-.26.37-.35.5Z',
      fill: '#a35f52'
    },
    {
      opacity: '.72',
      d: 'm97.37 317.43.08.1.07.12c-.03-.06-.11-.17-.15-.22Z',
      fill: '#a15f52'
    },
    {
      opacity: '.72',
      d: 'm275.55 347.53.08-.1c-.04.05-.11.16-.15.22l.07-.12Z',
      fill: '#a15f52'
    },
    {
      opacity: '.71',
      d: 'm108.38 333.43.07.09.08.12c-.04-.05-.12-.16-.15-.21Z',
      fill: '#9f5e51'
    },
    {
      opacity: '.76',
      d: 'm117.36 346.43.08.11.08.12c-.04-.06-.12-.17-.16-.23Z',
      fill: '#aa6154'
    },
    {
      opacity: '.7',
      d: 'm119.37 349.41.08.11.08.12a4.58 4.58 0 0 1-.16-.23Z',
      fill: '#9d5d52'
    },
    {
      d:
        'M1037.13 383.36c.45.28 1.34.84 1.78 1.11.38.32.77.64 1.17.98-.48 8.83-.55 17.73-.07 26.57 20.65.64 41.35.03 62.02.3 2.29.15 4.53-.33 6.7-1.11 10.09 1.3 20.32.91 30.42 1.68-33.38.26-66.77.04-100.15.11-.02-9 .02-18.01-.01-27.01.26-1.3-1.16-1.86-1.86-2.63Z',
      fill: '#eace1f'
    },
    {
      opacity: '.7',
      d:
        'M794.12 453.12c7.32-.3 14.67-.02 22-.14.57 14.67.14 29.39.22 44.08 1.72-.8 3.35-2.04 5.33-2.16-1.8 1.12-3.68 2.1-5.65 2.84-.07-14.57.01-29.13-.04-43.7-6.99-.07-13.98-.05-20.96-.01-.01 39.98-.06 79.97.01 119.95 6.79.03 13.59.01 20.38.02.48-16.11-.46-32.27.49-48.35.17 16.33.15 32.67.02 49-7.17-.03-14.36.24-21.52-.13-.1-.36-.3-1.07-.41-1.42.1-40-.15-79.99.13-119.98Z',
      fill: '#323232'
    },
    {
      d:
        'M795.02 454.03c6.98-.04 13.97-.06 20.96.01.05 14.57-.03 29.13.04 43.7 1.97-.74 3.85-1.72 5.65-2.84l.51-.25c.17-.15.52-.44.69-.59l1.27.02c.48-.24 1.44-.71 1.92-.95l.65-.07c5.22-.6 10.42-.54 15.66-.02l.64.11 1.98.81 1.04.11c.47.26 1.41.77 1.88 1.02l1.2-.03c.15.16.46.49.61.66l.84.56c.47 1.2 1.32 1.77 2.54 1.71l.41-.01c2.18 2.79 4.76 5.22 7.42 7.56l.08.14c1.15 2.99 2.57 5.87 3.98 8.74l-.01.36c-.23 1.2.02 2.31.76 3.32.09.39.26 1.16.35 1.55-.27 18.1.02 36.22-.13 54.32-6.76.04-13.51.03-20.26.01-.21-11-.02-22.01-.08-33.02-.1-5.12.36-10.28-.52-15.35l.02-.84c.47-2.18-.12-4.51-1.82-6l-.19-.33c-1.33-3.56-4.71-6.21-8.49-6.57l-.54-.18c-1.9-1.18-4.36-1.32-6.22.02l-1.06.24c-.49.22-1.49.64-1.99.86l-1.01.5c-.16.13-.49.41-.65.55l-1.12.17c-2.38-.16-4.06 1.76-4.03 4.06l-.27 1.13c-.08.18-.23.55-.31.73l-.61.99c-.97 1.05-1.23 2.48-.95 3.86l.04.85c-.95 16.08-.01 32.24-.49 48.35-6.79-.01-13.59.01-20.38-.02-.07-39.98-.02-79.97-.01-119.95Z'
    },
    {
      d:
        'M618.09 492.26c3.19-.66 6.63-.64 9.83-.01 1.55.98 3.4 1.17 5.19.72.43.07 1.3.22 1.74.29.85.75 1.86 1.04 3.01.86l1.1-.01c.49.23 1.45.7 1.94.93l1.04.06c.48.25 1.43.75 1.91.99h1.26c.17.15.53.46.71.62l1.25.35c-.03.69-.09 2.05-.11 2.73l-.24 1.35c-.08.2-.23.58-.31.77l-.56 1.19c-.22.51-.68 1.53-.9 2.04l-.07.84c-.23.48-.7 1.44-.94 1.92l-.05 1.02-.96 1.92-.03 1.04c-.25.49-.73 1.47-.98 1.96l-.65.15c-.69-1.79-2.67-2.14-4.35-2.06l-.97-.09c-.52-.2-1.55-.61-2.06-.81-.3-.02-.89-.07-1.18-.09-3.67-1.65-7.8-.82-11.68-.93-3.76.13-8.53 2.66-8.1 7.02.44 3.66 4.29 5.27 7.43 6.02l.57.19 2 .76.96.19c.8.83 1.78 1.15 2.92.96l1.09-.05c.47.24 1.43.73 1.91.98l1.3.16c.18.1.52.29.7.38l.9.58c.73 1.2 2.05 1.88 3.48 1.83l.99.1c.17.15.5.46.67.61.48.39 1.44 1.16 1.92 1.55.49 2.01 1.97 3.48 3.99 3.97.4.48 1.19 1.45 1.59 1.93l.36.72.57 1.27c.16.17.47.51.63.68l-.08 1.31c-.2 1.13.12 2.11.96 2.94l.24.58c.08 3.53.09 7.07-.01 10.61l-.21.61c-.87.79-1.2 1.75-.99 2.89l.11 1.24c-.16.15-.46.45-.62.61l-.58.86c-1.21.49-1.77 1.34-1.71 2.56l.01.42a39.806 39.806 0 0 0-5.56 5.53l-.41-.01c-1.22-.07-2.05.5-2.5 1.72l-.79.6c-.17.11-.5.33-.66.44l-1.19.18c-.48.23-1.46.69-1.95.92l-.78.18c-.53.19-1.6.57-2.14.77l-1.18.1c-1.4-.3-2.82-.07-3.93.84l-.68.25c-3.52.1-7.04.06-10.55.07l-2.45-.36c-1.02-.77-2.14-.99-3.34-.68-.44-.08-1.31-.22-1.75-.29-.86-.78-1.85-1.08-2.98-.88h-1.11c-.5-.22-1.48-.68-1.98-.9l-1.06-.08c-.48-.23-1.44-.7-1.93-.94l-1.34-.22c-.19-.08-.56-.25-.75-.34l-.92-.55c-1.27-1.1-2.48-2.28-3.29-3.75l.5-1.32c.08-.18.24-.56.32-.74l.5-.99c.23-.48.69-1.45.92-1.94l.22-1.27c.08-.19.25-.57.33-.76l.52-1.04c.24-.49.7-1.45.93-1.93l.21-1.25c.08-.19.23-.57.31-.75l.56-1.18c.28-.49.82-1.46 1.09-1.95l.96.39c.17.08.52.24.7.33l1.23.62c.18.09.55.27.73.36l1.28.64c.18.08.55.26.73.34l1.31.6c.18.08.54.25.72.34l1.11.54c.48.22 1.44.66 1.93.88l.58-.02c4.58 1.42 9.65 1.55 14.24.12l.52-.02c.45-.24 1.37-.73 1.83-.97l.86-.12c2.1.26 3.69-1.64 3.16-3.66-.09-1.44-.13-2.87-.13-4.29.35-1.82-1.26-3.27-3.01-3.1l-.77-.08c-.79-1.93-3.26-2.18-5.05-2l-1.12.06c-.63-1.01-1.57-1.36-2.81-1.06l-1.14-.01c-.5-.21-1.5-.65-2-.86l-1.04-.1-1.92-.96-1.25-.21-.76-.36-1.25-.61-.68-.4-.8-.58c-.44-1.19-1.27-1.8-2.48-1.86l-.76-.1c-.24-2.16-1.96-3.6-3.96-4.09l-1.48-1.88-.13-.47-.4-.27-.57-1.21c-.09-.19-.26-.57-.35-.76l-.11-1.24c.18-1.16-.13-2.14-.94-2.97l-.23-1.14c.14-2.23.17-4.47-.08-6.68.09-.49.27-1.47.35-1.96.78-.86 1.08-1.86.92-2.99l-.06-1.32c.15-.17.44-.52.59-.69l.57-1.31c.1-.17.3-.51.41-.68l.58-.77c1.21-.43 1.81-1.23 1.8-2.42l.01-.7c.37-.38 1.1-1.14 1.47-1.52.07-.07.2-.2.26-.27.37-.35 1.09-1.07 1.45-1.43l.75-.02c1.31.03 2.08-.62 2.31-1.93l.59-.11c1.96-.36 4.54-.8 5.36-2.92l.88.09c1.11.2 2.07-.12 2.88-.96l.79-.17c1.47.26 3.02.11 4.29-.77Z'
    },
    {
      d:
        'm1049.09 492.24.69-.26c3.19-.08 6.39-.06 9.6-.08.37.09 1.11.26 1.49.35 1.12.86 2.55 1.1 3.96.85l1.21.07c.54.2 1.62.6 2.15.8l.81.19c.5.21 1.51.64 2.02.85l1.2.27c.18.08.53.25.71.33l1.26.64c.17.09.52.27.7.36l1.22.66c.18.09.54.29.72.38.48.39 1.43 1.17 1.91 1.56.27 1.26 1.04 1.87 2.3 1.83h.85c.24.28.73.84.97 1.12 1.16 1.44 2.45 2.78 3.89 3.98.29.27.88.8 1.17 1.07l.03.82c-.04 1.31.6 2.06 1.91 2.26l.11.68c.17 2.03.99 4.15 2.83 5.24l.61.86c.09.18.25.55.33.74l.22 1.34c.23.49.69 1.48.92 1.97v1.11c-.19 1.14.11 2.15.89 3.04.07.33.22 1 .3 1.33-.14 4.85-.05 9.7-.06 14.56l-.24.72c-.81.84-1.11 1.84-.89 2.99l.02 1.11c-.23.47-.69 1.42-.91 1.89l.02.46c-1.6 2.55-3.01 5.21-4.06 8.04l-.16.36c-1.3.21-1.92.97-1.84 2.27l-.01.8-1.17 1.05a26.885 26.885 0 0 0-3.92 3.99c-.24.28-.72.83-.96 1.1l-.85.01c-1.25-.04-2.02.57-2.33 1.83-.48.4-1.44 1.19-1.93 1.58-.17.09-.52.28-.69.37l-1.21.63c-.17.1-.52.28-.7.37l-1.28.65c-.19.09-.55.27-.74.36l-1.23.2c-.48.24-1.44.72-1.91.95l-.83.09c-.52.22-1.57.66-2.1.88l-1.2.02c-1.18-.19-2.21.1-3.08.88-.38.07-1.14.23-1.52.31-3.88-.11-7.75-.12-11.61.03-.37-.09-1.12-.25-1.5-.34-.89-.77-1.9-1.07-3.04-.88l-1.14-.03c-.52-.21-1.55-.64-2.06-.86l-.87-.09c-.48-.25-1.43-.75-1.91-1l-1.27.01-.59-.63-.84-.59c-.56-1.1-1.44-1.69-2.62-1.78l-.54-.13c-.37-1.27-1.16-1.88-2.38-1.82l-.84.02c-.16-.21-.48-.63-.65-.84a21.569 21.569 0 0 0-5.65-5.62c-.18-.37-.54-1.1-.73-1.46 0-1.24-.62-2.03-1.84-2.36l-.11-.52c-.11-1.2-.7-2.08-1.77-2.62l-.6-.83c-.16-.14-.46-.43-.61-.57l-.02-1.3c-.26-.47-.78-1.41-1.04-1.87l-.1-.96c-.2-.5-.61-1.5-.81-2.01l-.07-.83c.2-1.2-.08-2.26-.83-3.19l-.24-.42c-.29-5.36-.26-10.72 0-16.08l.24-.44c.76-.86 1.05-1.85.87-2.97l-.02-1.11c.23-.48.67-1.43.89-1.9l-.03-.41c1.64-2.55 3-5.26 4.13-8.07l.17-.39c1.64-.16 3.02-1.55 2.75-3.27l.03-.89c.28-.21.82-.65 1.09-.87 1.14-.84 2.15-1.86 3.04-2.98l1.01-1.17.81.01c1.21.05 1.97-.56 2.3-1.82.47-.39 1.42-1.17 1.9-1.56.17-.09.52-.28.7-.37l1.23-.65c.18-.09.53-.28.7-.37l1.27-.64c.19-.09.56-.27.74-.36l1.23-.22c.48-.24 1.45-.71 1.93-.95l.96-.17c.52-.19 1.57-.58 2.09-.77l1.15-.05c1.36.25 2.78.01 3.9-.87m-.06 21.84-1.17.38-.72.32-1.26.6c-.16.08-.48.25-.64.33l-.64.36c-1.84-.34-2.84 1.44-4.05 2.43-1.02 1.23-2.8 2.29-2.46 4.17l-.29.63c-.15.16-.45.49-.59.65l-.39 1.24c-.08.2-.26.61-.35.81l-.35 1.22c-1.75-.17-1.98 2.84-.9 3.78-.44 1.6-.4 3.39-.02 5.02-1.26 1.6-.28 5.85 1.8 5.93l.23.76c-.56 1.72 0 2.56 1.67 2.52l.11.31c.38 2.49 3.02 5.18 5.6 5.37l.66.32c.16.14.49.41.65.54l1.23.48.77.32 1.15.34c.45 1.55 1.43 1.84 2.94.86 1.6.42 3.4.41 5.03-.01 1.57 1.3 5.82.32 5.9-1.8l1.1-.26c.15-.16.46-.46.62-.62.54-.34 1.64-1.04 2.18-1.38 2.05 1.06 4.93-1.78 3.85-3.84l.38-.72c2.05.25 3.95-3.54 2.74-5.23l.13-.53c1.68-3.47 1.6-8.14 0-11.63l-.2-.63c1.23-1.68-.55-5.58-2.66-5.27l-.4-.71c1.1-2.04-1.78-4.92-3.81-3.87-.54-.36-1.62-1.06-2.15-1.41-.16-.15-.48-.46-.64-.61l-1.23-.42-.8-.32-1.16-.41c-.48-1.59-1.48-1.85-2.99-.79-1.86-.54-3.97-.53-5.81-.03-1.52-1.02-2.54-.75-3.06.8Z'
    },
    {
      d:
        'M1242.09 493c6.92 0 13.85.01 20.78 0 .04 2.04.11 4.09.23 6.15 1.28-.64 2.54-1.33 3.79-2.05l.27-.02c.46-.25 1.37-.76 1.82-1.02l.94-.09 2.09-.8 1.1-.06c1.12.19 2.12-.1 3-.86l1.23-.36c4.6.21 9.22.08 13.84.1l.71.24c.82.79 1.82 1.08 2.98.89l1.1-.02c.49.24 1.45.72 1.93.96l1.02.03c.47.26 1.42.76 1.89 1.02l1.28.01c.14.14.42.43.57.57l.83.63c.54 1.06 1.41 1.65 2.61 1.76l.56.13c.34 1.24 1.12 1.85 2.36 1.84l.88.02c.17.2.49.59.65.78 1.59 2.08 3.47 3.91 5.5 5.57.23.19.67.58.9.78l.02.82c-.05 1.31.59 2.08 1.91 2.31l.09.61c.19 2.04.97 4.23 2.87 5.29l.55.93c.1.18.29.55.38.73l.06 1.28c-.18 1.13.14 2.1.97 2.92l.16.71c-.23 1.21.03 2.32.78 3.32.09.35.28 1.05.37 1.4-.1 3.72-.1 7.45.02 11.17-.09.31-.28.92-.37 1.23-.9 1.1-1.16 2.5-.89 3.89l.01 1.11c-.23.49-.68 1.47-.91 1.97l-.08 1.02c-.24.48-.74 1.44-.98 1.92v1.26c-.15.16-.47.49-.62.65l-.63 1.37c-.07.16-.23.48-.3.64l-1.59 2.47c-.1.17-.32.51-.43.68-.3.42-.91 1.26-1.21 1.67a37.582 37.582 0 0 0-8.64 8.57c-.16.21-.48.62-.63.83l-.88.04c-1.9-.14-3.89.91-4.36 2.85l-.78.03c-1.57-.06-3.62.33-4.13 2.05l-.89-.09c-1.14-.23-2.11.09-2.9.95l-1.04.13c-1.44-.27-2.9-.05-4.07.82-.5.07-1.51.22-2.01.29-1.87-.09-3.73-.1-5.56 0-.76-.07-2.27-.22-3.02-.29-1.17-.88-2.61-1.09-3.98-.88l-1.2.02c-.49-.23-1.46-.7-1.94-.93l-1.06-.07c-.48-.24-1.46-.71-1.94-.94l-1.25-.23c-.17-.1-.5-.31-.67-.42l-.74-.47c-.59-.28-1.77-.85-2.37-1.13-.2 13.47.02 26.95-.1 40.43-6.99.04-13.97.06-20.94-.01-.01-39.71-.13-79.42.06-119.12m39.04 21.97c-.5.07-1.48.21-1.97.29-.47-.03-1.41-.07-1.87-.09l-.18.85-1.13.44c-.2.09-.58.27-.78.36l-.92.43c-1.77-.55-2.58.04-2.43 1.76-.49.4-1.47 1.18-1.96 1.57l-.34.34c-.39.5-1.16 1.5-1.55 2.01-1.68-.16-2.29.61-1.82 2.31l-.15.8c-2-.09-3.02 3.63-1.78 5.05l-.27 1.1c-1.88.58-1.84 5.04.01 5.63l.23 1.12c-1.01 1.53-.71 2.5.87 2.91l.37 1.19c.08.19.26.59.34.79l.44 1.26c.14.16.42.49.56.66l.29.64c-.45 1.6 1.1 2.53 1.95 3.59 1.35 1.18 2.52 3.16 4.62 2.88l.59.34c.18.09.54.28.72.38l1.09.36.12.88.97.47.83-.43.68.09.34.99c3.4-.15 7.23.88 10.31-1l.53-.23c1.68 1.33 5.57-.49 5.21-2.67.43-.32 1.29-.98 1.71-1.3 1.77.47 2.43-.2 2-2 .33-.43.99-1.29 1.31-1.73 2.17.39 3.86-3.41 2.74-5.11l.07-.66 1.06-.34c-.2-3.76.93-7.94-.98-11.37l-.07-.55.41-.84-.51-.95-.91-.08-.08-1.17c-.16-.17-.49-.49-.66-.66l-.32-.68c-.82-2.96-3.37-5.56-6.24-6.55-.42-.24-1.27-.72-1.7-.96.24-2.01-3.49-3.13-4.89-1.93l-1.15-.19c-.54-1.79-5.19-1.78-5.71 0Z'
    },
    {
      opacity: '.37',
      d: 'M1049.78 491.98c2.86-1.32 6.86-1.71 9.6-.08-3.21.02-6.41 0-9.6.08Z',
      fill: '#292929'
    },
    {
      opacity: '.78',
      d: 'M613.8 493.03c.22-1.6 3.15-1.48 4.29-.77-1.27.88-2.82 1.03-4.29.77Z',
      fill: '#363636'
    },
    {
      opacity: '.78',
      d: 'M627.92 492.25c1.41-.63 4.55-.86 5.19.72-1.79.45-3.64.26-5.19-.72Z',
      fill: '#353535'
    },
    {
      opacity: '.82',
      d:
        'M826.71 493.06c2.42-1.74 5.5-.88 8.27-1.07 2.47.13 5.24-.55 7.39 1.05-5.24-.52-10.44-.58-15.66.02Z',
      fill: '#272727'
    },
    {
      opacity: '.74',
      d: 'M1045.19 493.11c-.08-1.7 2.87-1.69 3.9-.87-1.12.88-2.54 1.12-3.9.87Z',
      fill: '#333'
    },
    {
      opacity: '.73',
      d: 'M1060.87 492.25c1-.83 3.92-.84 3.96.85-1.41.25-2.84.01-3.96-.85Z',
      fill: '#333'
    },
    {
      opacity: '.76',
      d: 'M610.13 494.16c.36-1.53 1.33-1.85 2.88-.96-.81.84-1.77 1.16-2.88.96Z',
      fill: '#2f2f2f'
    },
    {
      opacity: '.68',
      d: 'M634.85 493.26c1.53-.95 2.53-.66 3.01.86-1.15.18-2.16-.11-3.01-.86Z',
      fill: '#353535'
    },
    {
      opacity: '.69',
      d: 'm824.24 493.21 1.82-.08c-.48.24-1.44.71-1.92.95l.1-.87Z',
      fill: '#383838'
    },
    {
      opacity: '.8',
      d: 'M843.01 493.15c.46-.01 1.39-.01 1.85-.02l.13.83-1.98-.81Z',
      fill: '#383838'
    },
    {
      opacity: '.8',
      d:
        'M1042.15 493.11c.47.02 1.42.04 1.89.05-.52.19-1.57.58-2.09.77l.2-.82Z',
      fill: '#373737'
    },
    {
      opacity: '.8',
      d: 'M1066.04 493.17h1.97l.18.8c-.53-.2-1.61-.6-2.15-.8Z',
      fill: '#393939'
    },
    {
      opacity: '.73',
      d:
        'm1241.01 492.99 1.08.01c-.19 39.7-.07 79.41-.06 119.12 6.97.07 13.95.05 20.94.01.12-13.48-.1-26.96.1-40.43.6.28 1.78.85 2.37 1.13l-1.47.36c-.34 13.22.14 26.46-.24 39.68-7.52.25-15.05.15-22.57.05-.36-39.97-.07-79.95-.15-119.93Z',
      fill: '#3e3e3e'
    },
    {
      opacity: '.73',
      d:
        'M1262.87 493h.98c.02 1.69.06 3.39.09 5.09.74-.24 2.22-.74 2.95-.99-1.25.72-2.51 1.41-3.79 2.05-.12-2.06-.19-4.11-.23-6.15Z',
      fill: '#313131'
    },
    {
      opacity: '.65',
      d:
        'M1277.34 493.89c1.63-1.14 3.68-.87 5.58-.92 2.76.06 5.7-.34 8.26 1.02-4.62-.02-9.24.11-13.84-.1Z',
      fill: '#383838'
    },
    {
      opacity: '.65',
      d:
        'M1096.07 526.6c1.21 1.92.9 4.24.95 6.4-.07 2.74.34 5.64-1.01 8.16.01-4.86-.08-9.71.06-14.56Z',
      fill: '#383838'
    },
    {
      opacity: '.75',
      d:
        'M603.89 496.99c.31-1.83 3.63-2.86 5.36-2.92-.82 2.12-3.4 2.56-5.36 2.92Z',
      fill: '#242424'
    },
    {
      opacity: '.74',
      d: 'm638.96 494.11 1.85.08.09.85c-.49-.23-1.45-.7-1.94-.93Z',
      fill: '#3a3a3a'
    },
    {
      opacity: '.74',
      d: 'M611.08 541c.5.21 1.5.65 2 .86-.47 0-1.39-.01-1.86-.02l-.14-.84Z',
      fill: '#3a3a3a'
    },
    {
      opacity: '.77',
      d: 'M822.18 494.65c.17-.15.52-.44.69-.59-.17.15-.52.44-.69.59Z',
      fill: '#404040'
    },
    { opacity: '.77', d: 'm604.18 538.36.68.4-.68-.4Z', fill: '#404040' },
    {
      opacity: '.74',
      d: 'm846.03 494.07 1.79.16.09.86c-.47-.25-1.41-.76-1.88-1.02Z',
      fill: '#353535'
    },
    {
      opacity: '.77',
      d:
        'M1039.17 494.19c.45-.02 1.36-.06 1.82-.09-.48.24-1.45.71-1.93.95l.11-.86Z',
      fill: '#353535'
    },
    {
      opacity: '.78',
      d: 'M1069 494.16h1.84l.18.85c-.51-.21-1.52-.64-2.02-.85Z',
      fill: '#343434'
    },
    {
      opacity: '.75',
      d: 'M1273.11 495.11c.42-1.52 1.42-1.8 3-.86-.88.76-1.88 1.05-3 .86Z',
      fill: '#363636'
    },
    {
      opacity: '.75',
      d:
        'M1288.81 576.75c1.17-.87 2.63-1.09 4.07-.82-.07 1.68-3.03 1.56-4.07.82Z',
      fill: '#363636'
    },
    {
      opacity: '.73',
      d: 'M1291.89 494.23c1.54-.92 2.53-.63 2.98.89-1.16.19-2.16-.1-2.98-.89Z',
      fill: '#363636'
    },
    {
      opacity: '.73',
      d:
        'm592.19 557.2.86-.1c-.23.48-.69 1.44-.93 1.93.02-.46.05-1.37.07-1.83Z',
      fill: '#363636'
    },
    {
      opacity: '.69',
      d:
        'M641.94 495.1c.46.03 1.37.1 1.83.13l.08.86c-.48-.24-1.43-.74-1.91-.99Z',
      fill: '#373737'
    },
    {
      opacity: '.65',
      d: 'M849.11 495.06c.15.16.46.49.61.66-.15-.17-.46-.5-.61-.66Z',
      fill: '#3d3d3d'
    },
    {
      opacity: '.65',
      d: 'M596.18 552.36c.17.08.52.24.7.33-.18-.09-.53-.25-.7-.33Z',
      fill: '#3d3d3d'
    },
    {
      opacity: '.65',
      d: 'M1076.09 569.73c.17-.09.52-.28.69-.37-.17.09-.52.28-.69.37Z',
      fill: '#3d3d3d'
    },
    { opacity: '.76', d: 'M1037.09 495.63Z', fill: '#404040' },
    {
      opacity: '.76',
      d: 'M591.27 560.83c.08-.19.25-.57.33-.76-.08.19-.25.57-.33.76Z',
      fill: '#404040'
    },
    {
      opacity: '.78',
      d: 'M1072.22 495.28c.18.08.53.25.71.33-.18-.08-.53-.25-.71-.33Z',
      fill: '#3e3e3e'
    },
    { opacity: '.78', d: 'M1318.34 558.9Z', fill: '#3e3e3e' },
    {
      opacity: '.8',
      d: 'M1270.13 495.14c.47.01 1.41.02 1.88.03l-2.09.8.21-.83Z',
      fill: '#373737'
    },
    {
      opacity: '.8',
      d:
        'M1066.09 573.86c.53-.22 1.58-.66 2.1-.88l-.12.81c-.5.02-1.48.05-1.98.07Z',
      fill: '#373737'
    },
    {
      opacity: '.76',
      d:
        'M1295.97 495.1c.46.03 1.38.08 1.84.1l.09.86c-.48-.24-1.44-.72-1.93-.96Z',
      fill: '#383838'
    },
    { opacity: '.73', d: 'm219.23 496.35.33.49-.33-.49Z', fill: '#a35f53' },
    {
      opacity: '.7',
      d: 'M645.11 496.09c.17.15.53.46.71.62-.18-.16-.54-.47-.71-.62Z',
      fill: '#3e3e3e'
    },
    {
      opacity: '.7',
      d: 'M593.1 508.84c.15-.17.44-.52.59-.69-.15.17-.44.52-.59.69Z',
      fill: '#3e3e3e'
    },
    {
      opacity: '.8',
      d:
        'M850.56 496.28c1.62-.32 2.47.25 2.54 1.71-1.22.06-2.07-.51-2.54-1.71Z',
      fill: '#242424'
    },
    {
      opacity: '.78',
      d: 'M1035.12 496.64c.18-.09.53-.28.7-.37-.17.09-.52.28-.7.37Z',
      fill: '#3f3f3f'
    },
    {
      opacity: '.78',
      d: 'M593.25 527.14c.09.19.26.57.35.76-.09-.19-.26-.57-.35-.76Z',
      fill: '#3f3f3f'
    },
    { opacity: '.78', d: 'M1074.18 570.73Z', fill: '#3f3f3f' },
    { opacity: '.78', d: 'M593.02 571.39Z', fill: '#3f3f3f' },
    { opacity: '.81', d: 'M1074.19 496.25Z', fill: '#3f3f3f' },
    {
      opacity: '.71',
      d: 'm1267.2 496.22 1.78-.16c-.45.26-1.36.77-1.82 1.02l.04-.86Z',
      fill: '#353535'
    },
    {
      opacity: '.64',
      d:
        'M1298.92 496.09c.45.04 1.35.1 1.8.14l.09.88c-.47-.26-1.42-.76-1.89-1.02Z',
      fill: '#333'
    },
    {
      opacity: '.84',
      d: 'M600.99 499.03c.02-1.42.79-2.07 2.31-1.93-.23 1.31-1 1.96-2.31 1.93Z',
      fill: '#272727'
    },
    {
      opacity: '.64',
      d: 'M647.07 497.06c1.67-.6 1.45 3.13-.11 2.73.02-.68.08-2.04.11-2.73Z',
      fill: '#373737'
    },
    {
      opacity: '.64',
      d: 'M1033.19 497.66c.17-.09.52-.28.7-.37-.18.09-.53.28-.7.37Z',
      fill: '#3d3d3d'
    },
    {
      opacity: '.69',
      d: 'M1076.11 497.27c.18.09.54.29.72.38-.18-.09-.54-.29-.72-.38Z',
      fill: '#3f3f3f'
    },
    {
      opacity: '.69',
      d: 'M637.18 529.13c.17.15.5.46.67.61-.17-.15-.5-.46-.67-.61Z',
      fill: '#3f3f3f'
    },
    {
      opacity: '.52',
      d: 'M1302.09 497.12c.14.14.42.43.57.57-.15-.14-.43-.43-.57-.57Z',
      fill: '#353535'
    },
    {
      opacity: '.84',
      d:
        'M853.51 497.98c3.12 1.62 5.99 4.31 7.42 7.56-2.66-2.34-5.24-4.77-7.42-7.56Z',
      fill: '#1f1f1f'
    },
    {
      opacity: '.76',
      d:
        'M1303.49 498.32c1.71-.36 2.58.23 2.61 1.76-1.2-.11-2.07-.7-2.61-1.76Z',
      fill: '#232323'
    },
    {
      opacity: '.85',
      d:
        'M1028.99 501.04c-.04-1.48.73-2.09 2.3-1.82-.33 1.26-1.09 1.87-2.3 1.82Z',
      fill: '#272727'
    },
    {
      opacity: '.88',
      d: 'M1078.74 499.21c1.53-.25 2.29.36 2.3 1.83-1.26.04-2.03-.57-2.3-1.83Z',
      fill: '#262626'
    },
    { opacity: '.26', d: 'M598.53 500.75Z', fill: '#1f1f1f' },
    {
      opacity: '.83',
      d:
        'M1306.66 500.21c1.58-.25 2.37.37 2.36 1.84-1.24.01-2.02-.6-2.36-1.84Z',
      fill: '#262626'
    },
    {
      opacity: '.74',
      d: 'M646.41 501.91c.08-.19.23-.57.31-.77-.08.2-.23.58-.31.77Z',
      fill: '#3f3f3f'
    },
    {
      opacity: '.22',
      d:
        'M1024.13 505.18c-1.04-1.72 1.33-4.08 3.04-2.98-.89 1.12-1.9 2.14-3.04 2.98Z',
      fill: '#191919'
    },
    {
      opacity: '.22',
      d:
        'M1082.86 502.16c2.1-.84 4.86 1.85 3.89 3.98-1.44-1.2-2.73-2.54-3.89-3.98Z',
      fill: '#191919'
    },
    {
      opacity: '.22',
      d:
        'M1082.85 564.84c1.17-1.46 2.47-2.8 3.92-3.99.92 2.15-1.78 4.79-3.92 3.99Z',
      fill: '#191919'
    },
    {
      opacity: '.8',
      d: 'M595.25 505.39c-.31-1.6.29-2.41 1.8-2.42.01 1.19-.59 1.99-1.8 2.42Z',
      fill: '#262626'
    },
    {
      opacity: '.8',
      d:
        'M644.95 505.14c.22-.51.68-1.53.9-2.04-.02.48-.05 1.43-.07 1.91l-.83.13Z',
      fill: '#353535'
    },
    {
      opacity: '.61',
      d:
        'M1310.55 502.85c2.34 1.2 4.4 3.15 5.5 5.57-2.03-1.66-3.91-3.49-5.5-5.57Z',
      fill: '#1e1e1e'
    },
    {
      opacity: '.75',
      d: 'M594.26 506.84c.1-.17.3-.51.41-.68-.11.17-.31.51-.41.68Z',
      fill: '#404040'
    },
    {
      opacity: '.75',
      d: 'M1275.2 516.82c.2-.09.58-.27.78-.36-.2.09-.58.27-.78.36Z',
      fill: '#404040'
    },
    {
      opacity: '.75',
      d: 'm594.17 529.11.4.27.13.47c-.14-.18-.4-.55-.53-.74Z',
      fill: '#404040'
    },
    {
      opacity: '.75',
      d: 'M589.31 565.77c.08-.18.24-.56.32-.74-.08.18-.24.56-.32.74Z',
      fill: '#404040'
    },
    {
      opacity: '.73',
      d: 'M643.94 507.9c.24-.48.71-1.44.94-1.92l-.08 1.82-.86.1Z',
      fill: '#383838'
    },
    {
      opacity: '.78',
      d:
        'M861.01 505.68c2.19 2.09 3.88 5.57 3.98 8.74-1.41-2.87-2.83-5.75-3.98-8.74Z',
      fill: '#222'
    },
    {
      opacity: '.84',
      d:
        'M1020.26 510.21c-.02-1.28 1.33-3.5 2.75-3.27.27 1.72-1.11 3.11-2.75 3.27Z',
      fill: '#202020'
    },
    {
      opacity: '.74',
      d:
        'M1087.95 508.03c1.37-.07 2.01.68 1.91 2.26-1.31-.2-1.95-.95-1.91-2.26Z',
      fill: '#252525'
    },
    {
      opacity: '.65',
      d: 'm642.93 510.84.96-1.92c-.02.45-.07 1.36-.09 1.82l-.87.1Z',
      fill: '#363636'
    },
    {
      opacity: '.67',
      d: 'M592.24 513.15c-.94-1.52-.63-2.52.92-2.99.16 1.13-.14 2.13-.92 2.99Z',
      fill: '#333'
    },
    {
      opacity: '.65',
      d:
        'M612.93 517.03c-.43-4.36 4.34-6.89 8.1-7.02 3.88.11 8.01-.72 11.68.93-6.23-.2-13.84-2.05-18.69 3.14-.01 1.53-.02 3.07 0 4.61 1.68 2.09 4.36 2.78 6.34 4.36-3.14-.75-6.99-2.36-7.43-6.02Z',
      fill: '#252525'
    },
    {
      opacity: '.76',
      d:
        'M1316.97 510.02c1.38-.03 2.01.74 1.91 2.31-1.32-.23-1.96-1-1.91-2.31Z',
      fill: '#262626'
    },
    {
      opacity: '.78',
      d:
        'M633.89 511.03c.51.2 1.54.61 2.06.81-.49-.01-1.45-.02-1.94-.03l-.12-.78Z',
      fill: '#383838'
    },
    {
      opacity: '.84',
      d: 'M827.86 511.71c1.86-1.34 4.32-1.2 6.22-.02-1.9.67-4.33.67-6.22.02Z',
      fill: '#3a3a3a'
    },
    {
      opacity: '.77',
      d:
        'M1015.96 518.67c.5-2.93 1.95-6.03 4.13-8.07-1.13 2.81-2.49 5.52-4.13 8.07Z',
      fill: '#222'
    },
    {
      opacity: '.74',
      d:
        'M1089.97 510.97c1.69.22 3.2 3.56 2.83 5.24-1.84-1.09-2.66-3.21-2.83-5.24Z',
      fill: '#242424'
    },
    {
      opacity: '.76',
      d: 'M636.92 511.93c1.68-.08 3.66.27 4.35 2.06-1.36.08-4.2-.57-4.35-2.06Z',
      fill: '#272727'
    },
    {
      opacity: '.56',
      d:
        'M641.92 513.84c.25-.49.73-1.47.98-1.96-.04.46-.1 1.39-.13 1.85l-.85.11Z',
      fill: '#333'
    },
    {
      opacity: '.52',
      d: 'M824.81 512.81c.5-.22 1.5-.64 1.99-.86l-.15.87-1.01.45-.83-.46Z',
      fill: '#2f2f2f'
    },
    {
      opacity: '.78',
      d:
        'M834.62 511.87c3.78.36 7.16 3.01 8.49 6.57-2.37-2.76-5.24-4.94-8.49-6.57Z',
      fill: '#222'
    },
    { opacity: '.67', d: 'M823.15 513.86Z', fill: '#3c3c3c' },
    {
      opacity: '.63',
      d: 'M1049.03 514.08c.52-1.55 1.54-1.82 3.06-.8-.92.69-1.94.96-3.06.8Z',
      fill: '#343434'
    },
    {
      opacity: '.68',
      d: 'M1057.9 513.31c1.51-1.06 2.51-.8 2.99.79-1.12.13-2.12-.13-2.99-.79Z',
      fill: '#343434'
    },
    {
      opacity: '.73',
      d:
        'M1318.97 512.94c1.75.3 3.1 3.59 2.87 5.29-1.9-1.06-2.68-3.25-2.87-5.29Z',
      fill: '#242424'
    },
    {
      opacity: '.91',
      d:
        'M818 518.09c-.03-2.3 1.65-4.22 4.03-4.06-.54 1.42-2.6 3.53-4.03 4.06Z',
      fill: '#212121'
    },
    { opacity: '.62', d: 'm1047.14 514.78.72-.32-.72.32Z', fill: '#3b3b3b' },
    { opacity: '.71', d: 'm1062.05 514.51.8.32-.8-.32Z', fill: '#3e3e3e' },
    {
      opacity: '.71',
      d: 'M1064.08 515.25c.16.15.48.46.64.61-.16-.15-.48-.46-.64-.61Z',
      fill: '#3e3e3e'
    },
    {
      opacity: '.71',
      d: 'M631.11 526.24c.18.1.52.29.7.38-.18-.09-.52-.28-.7-.38Z',
      fill: '#3e3e3e'
    },
    {
      opacity: '.88',
      d: 'M1281.13 514.97c.52-1.78 5.17-1.79 5.71 0-1.92.08-3.83.08-5.71 0Z',
      fill: '#373737'
    },
    {
      opacity: '.49',
      d: 'M591.97 521.79c-1.74-.91-1.72-5.82-.08-6.68.25 2.21.22 4.45.08 6.68Z',
      fill: '#323232'
    },
    {
      opacity: '.81',
      d: 'M864.98 514.78c1.39.59 1.64 1.7.76 3.32-.74-1.01-.99-2.12-.76-3.32Z',
      fill: '#363636'
    },
    {
      opacity: '.57',
      d: 'M1045.24 515.71c.16-.08.48-.25.64-.33-.16.08-.48.25-.64.33Z',
      fill: '#383838'
    },
    {
      opacity: '.74',
      d:
        'M1277.29 515.17c.46.02 1.4.06 1.87.09-.52.19-1.54.57-2.05.76l.18-.85Z',
      fill: '#393939'
    },
    {
      opacity: '.68',
      d:
        'M1287.99 515.16c1.4-1.2 5.13-.08 4.89 1.93-1.72-.44-3.43-.94-4.89-1.93Z',
      fill: '#272727'
    },
    {
      opacity: '.82',
      d:
        'M1040.55 518.5c1.21-.99 2.21-2.77 4.05-2.43a31.333 31.333 0 0 0-6.51 6.6c-.34-1.88 1.44-2.94 2.46-4.17Z',
      fill: '#212121'
    },
    {
      opacity: '.88',
      d:
        'M1066.87 517.27c2.03-1.05 4.91 1.83 3.81 3.87-1.37-1.2-2.64-2.5-3.81-3.87Z',
      fill: '#232323'
    },
    { opacity: '.78', d: 'M1093.41 517.07Z', fill: '#3f3f3f' },
    {
      opacity: '.78',
      d: 'M593.26 555.85c.08-.19.23-.57.31-.75-.08.18-.23.56-.31.75Z',
      fill: '#3f3f3f'
    },
    {
      opacity: '.76',
      d:
        'M1271.85 519.01c-.15-1.72.66-2.31 2.43-1.76-.6.89-1.41 1.47-2.43 1.76Z',
      fill: '#252525'
    },
    {
      opacity: '.6',
      d:
        'M1294.58 518.05c2.87.99 5.42 3.59 6.24 6.55-1.91-2.35-4.02-4.51-6.24-6.55Z',
      fill: '#1e1e1e'
    },
    {
      opacity: '.8',
      d: 'M817.42 519.95c.08-.18.23-.55.31-.73-.08.18-.23.55-.31.73Z',
      fill: '#3d3d3d'
    },
    {
      opacity: '.68',
      d: 'M843.3 518.77c1.7 1.49 2.29 3.82 1.82 6-1.75-.72-1.83-4.33-1.82-6Z',
      fill: '#292929'
    },
    {
      opacity: '.79',
      d:
        'm1015.17 519.17.82-.09c-.22.47-.66 1.42-.89 1.9.02-.45.05-1.36.07-1.81Z',
      fill: '#373737'
    },
    {
      opacity: '.66',
      d:
        'm1093.96 519.15.85.11c.02.47.05 1.4.07 1.86-.23-.49-.69-1.48-.92-1.97Z',
      fill: '#393939'
    },
    { opacity: '.74', d: 'M1322.39 519.16Z', fill: '#404040' },
    {
      opacity: '.74',
      d: 'M1301.14 525.28c.17.17.5.49.66.66-.16-.17-.49-.49-.66-.66Z',
      fill: '#404040'
    },
    { opacity: '.74', d: 'm606.11 539.37.76.36-.76-.36Z', fill: '#404040' },
    {
      opacity: '.79',
      d:
        'M866.09 519.65c1.07 2.64.84 5.55.92 8.34-.06 15.32.06 30.64-.06 45.95l-.33.52c-7.15.37-14.33.05-21.48.15-.26-16.32-.18-32.67-.04-49 .88 5.07.42 10.23.52 15.35.06 11.01-.13 22.02.08 33.02 6.75.02 13.5.03 20.26-.01.15-18.1-.14-36.22.13-54.32Z',
      fill: '#313131'
    },
    { opacity: '.94', d: 'm1269.55 520.92.34-.34-.34.34Z', fill: '#2e2e2e' },
    {
      opacity: '.62',
      d: 'M815.86 524.8c-.28-1.38-.02-2.81.95-3.86.82 1.01.66 3.83-.95 3.86Z',
      fill: '#2f2f2f'
    },
    {
      opacity: '.72',
      d:
        'M1322.83 521.17c1.52.39 1.85 1.36.97 2.92-.83-.82-1.15-1.79-.97-2.92Z',
      fill: '#2f2f2f'
    },
    {
      opacity: '.78',
      d:
        'M1014.25 525.06c-.96-1.55-.67-2.54.87-2.97.18 1.12-.11 2.11-.87 2.97Z',
      fill: '#333'
    },
    {
      opacity: '.73',
      d:
        'M1071.08 521.85c2.11-.31 3.89 3.59 2.66 5.27-1.12-1.64-1.91-3.46-2.66-5.27Z',
      fill: '#232323'
    },
    {
      opacity: '.63',
      d: 'M1094.88 522.23c1.5.45 1.79 1.47.89 3.04-.78-.89-1.08-1.9-.89-3.04Z',
      fill: '#353535'
    },
    {
      opacity: '.76',
      d: 'M592.2 522.93c.81.83 1.12 1.81.94 2.97-1.53-.43-1.84-1.42-.94-2.97Z',
      fill: '#313131'
    },
    {
      opacity: '.73',
      d: 'M620.93 523.24c.46-.02 1.39-.07 1.85-.09l.15.85-2-.76Z',
      fill: '#3a3a3a'
    },
    { opacity: '.66', d: 'M1037.21 523.95Z', fill: '#3e3e3e' },
    {
      opacity: '.8',
      d:
        'M1266.18 525.24c-.47-1.7.14-2.47 1.82-2.31-.25 1.11-.86 1.89-1.82 2.31Z',
      fill: '#252525'
    },
    {
      opacity: '.67',
      d: 'M623.89 524.19c1.51-.9 2.49-.58 2.92.96-1.14.19-2.12-.13-2.92-.96Z',
      fill: '#323232'
    },
    {
      opacity: '.71',
      d: 'm239.37 525.43.08.09.08.12c-.04-.05-.12-.16-.16-.21Z',
      fill: '#9f5c50'
    },
    {
      opacity: '.59',
      d: 'm627.9 525.1 1.82.12.09.86c-.48-.25-1.44-.74-1.91-.98Z',
      fill: '#353535'
    },
    { opacity: '.72', d: 'M1036.47 526Z', fill: '#404040' },
    {
      opacity: '.78',
      d: 'M1323.96 524.8c1.39.61 1.65 1.71.78 3.32-.75-1-1.01-2.11-.78-3.32Z',
      fill: '#383838'
    },
    {
      opacity: '.78',
      d:
        'M1040.94 572.99c.51.22 1.54.65 2.06.86-.48-.01-1.42-.02-1.89-.03l-.17-.83Z',
      fill: '#383838'
    },
    {
      opacity: '.79',
      d:
        'M1012.99 534c.14-2.84-.56-5.93 1.02-8.5-.26 5.36-.29 10.72 0 16.08-1.5-2.26-.92-5.05-1.02-7.58Z',
      fill: '#343434'
    },
    {
      opacity: '.71',
      d:
        'M1264.25 531.09c-1.24-1.42-.22-5.14 1.78-5.05-.33 1.76-.91 3.48-1.78 5.05Z',
      fill: '#292929'
    },
    {
      opacity: '.73',
      d: 'M632.71 527.2c1.13-.62 3.75.36 3.48 1.83-1.43.05-2.75-.63-3.48-1.83Z',
      fill: '#272727'
    },
    {
      opacity: '.6',
      d: 'M1035.22 531c-1.08-.94-.85-3.95.9-3.78.13 1.32-.16 2.65-.9 3.78Z',
      fill: '#2f2f2f'
    },
    {
      opacity: '.59',
      d: 'm1301.88 527.11.91.08.51.95-.41.84c-.25-.47-.76-1.4-1.01-1.87Z',
      fill: '#343434'
    },
    {
      opacity: '.51',
      d: 'M1073.94 527.75c1.6 3.49 1.68 8.16 0 11.63.63-3.86.51-7.76 0-11.63Z',
      fill: '#2c2c2c'
    },
    {
      opacity: '.48',
      d:
        'M1302.96 529.53c1.91 3.43.78 7.61.98 11.37l-1.06.34c.63-3.9.71-7.81.08-11.71Z',
      fill: '#2b2b2b'
    },
    {
      opacity: '.57',
      d:
        'M1325.11 529.52c1.33 3.41 1.44 7.8.02 11.17-.12-3.72-.12-7.45-.02-11.17Z',
      fill: '#383838'
    },
    {
      opacity: '.76',
      d:
        'M639.77 531.29c1.76-.09 4.1 2.2 3.99 3.97-2.02-.49-3.5-1.96-3.99-3.97Z',
      fill: '#212121'
    },
    {
      opacity: '.77',
      d:
        'M596.18 531.73c2 .49 3.72 1.93 3.96 4.09-1.7-.29-4.04-2.29-3.96-4.09Z',
      fill: '#212121'
    },
    {
      opacity: '.96',
      d:
        'M1263.99 537.82c-1.85-.59-1.89-5.05-.01-5.63.04 1.87.04 3.75.01 5.63Z',
      fill: '#262626'
    },
    {
      opacity: '.86',
      d: 'M600.9 535.92c1.21.06 2.04.67 2.48 1.86-1.65.25-2.48-.37-2.48-1.86Z',
      fill: '#242424'
    },
    {
      opacity: '.64',
      d:
        'M1035.2 536.02c.88 1.87 1.39 3.89 1.8 5.93-2.08-.08-3.06-4.33-1.8-5.93Z',
      fill: '#272727'
    },
    { opacity: '.67', d: 'm645.35 537.19.36.72-.36-.72Z', fill: '#3e3e3e' },
    {
      opacity: '.69',
      d: 'M646.28 539.18c.16.17.47.51.63.68-.16-.17-.47-.51-.63-.68Z',
      fill: '#3f3f3f'
    },
    {
      opacity: '.65',
      d:
        'M1264.22 538.94c.72.82 1.02 1.79.87 2.91-1.58-.41-1.88-1.38-.87-2.91Z',
      fill: '#333'
    },
    {
      opacity: '.72',
      d: 'm608.12 539.94 1.92.96c-.45-.03-1.37-.08-1.83-.1l-.09-.86Z',
      fill: '#363636'
    },
    {
      opacity: '.7',
      d:
        'M1071.07 545.14c.74-1.82 1.53-3.65 2.74-5.23 1.21 1.69-.69 5.48-2.74 5.23Z',
      fill: '#232323'
    },
    { opacity: '.67', d: 'M250.37 541.4Z', fill: '#96594e' },
    {
      opacity: '.69',
      d: 'M646.83 541.17c1.52.41 1.84 1.4.96 2.94-.84-.83-1.16-1.81-.96-2.94Z',
      fill: '#323232'
    },
    {
      opacity: '.66',
      d: 'M614.22 541.87c1.24-.3 2.18.05 2.81 1.06-1.52.73-2.45.38-2.81-1.06Z',
      fill: '#343434'
    },
    {
      opacity: '.82',
      d: 'M1014.25 542c.75.93 1.03 1.99.83 3.19-1.46-.57-1.74-1.64-.83-3.19Z',
      fill: '#323232'
    },
    {
      opacity: '.71',
      d: 'M1094.88 544.87c-.22-1.15.08-2.15.89-2.99.9 1.55.6 2.55-.89 2.99Z',
      fill: '#363636'
    },
    {
      opacity: '.76',
      d:
        'M1300.07 547.01c.87-1.72 1.44-3.65 2.74-5.11 1.12 1.7-.57 5.5-2.74 5.11Z',
      fill: '#242424'
    },
    {
      opacity: '.73',
      d: 'M1323.87 545.81c-.27-1.39-.01-2.79.89-3.89.8.99.79 3.96-.89 3.89Z',
      fill: '#323232'
    },
    {
      opacity: '.7',
      d: 'm141.55 543.52.07-.1c-.04.06-.11.17-.15.22l.08-.12Z',
      fill: '#9d5d51'
    },
    {
      opacity: '.72',
      d: 'M618.15 542.87c1.79-.18 4.26.07 5.05 2-1.5-.04-4.66-.38-5.05-2Z',
      fill: '#292929'
    },
    {
      opacity: '.67',
      d:
        'M1037.23 542.71c.91.57 1.47 1.41 1.67 2.52-1.67.04-2.23-.8-1.67-2.52Z',
      fill: '#212121'
    },
    {
      opacity: '.67',
      d: 'M1265.46 543.04c.08.19.26.59.34.79-.08-.2-.26-.6-.34-.79Z',
      fill: '#3d3d3d'
    },
    {
      opacity: '.82',
      d:
        'M623.97 544.95c1.75-.17 3.36 1.28 3.01 3.1-1.15-.12-3.03-1.92-3.01-3.1Z',
      fill: '#252525'
    },
    {
      opacity: '.58',
      d: 'M648.03 544.69c1.47 3.16 1.6 7.49-.01 10.61.1-3.54.09-7.08.01-10.61Z',
      fill: '#373737'
    },
    { opacity: '.64', d: 'M1266.24 545.09Z', fill: '#3c3c3c' },
    {
      opacity: '.83',
      d:
        'M1015.15 546.02c.2.51.61 1.51.81 2.01l-.83-.15c.01-.46.01-1.39.02-1.86Z',
      fill: '#343434'
    },
    {
      opacity: '.84',
      d:
        'M1039.01 545.54c1.72 1.92 3.56 3.75 5.6 5.37-2.58-.19-5.22-2.88-5.6-5.37Z',
      fill: '#222'
    },
    {
      opacity: '.91',
      d:
        'M1066.84 549.7c1.2-1.36 2.47-2.65 3.85-3.84 1.08 2.06-1.8 4.9-3.85 3.84Z',
      fill: '#222'
    },
    {
      opacity: '.74',
      d:
        'M1093.99 547.87c.22-.47.68-1.42.91-1.89-.02.46-.07 1.37-.09 1.82l-.82.07Z',
      fill: '#393939'
    },
    {
      opacity: '.84',
      d:
        'M1267.09 546.39c1.86 2.46 4.07 4.65 6.57 6.47-2.1.28-3.27-1.7-4.62-2.88-.85-1.06-2.4-1.99-1.95-3.59Z',
      fill: '#202020'
    },
    {
      opacity: '.73',
      d:
        'M1322.97 548.89c.23-.5.68-1.48.91-1.97-.01.46-.05 1.39-.06 1.85l-.85.12Z',
      fill: '#393939'
    },
    {
      opacity: '.7',
      d:
        'M1016.06 548.99c.26.46.78 1.4 1.04 1.87l-.87-.08c-.04-.45-.13-1.35-.17-1.79Z',
      fill: '#343434'
    },
    {
      opacity: '.77',
      d:
        'M1089.95 556.37c1.05-2.83 2.46-5.49 4.06-8.04-.5 2.9-1.89 6.07-4.06 8.04Z',
      fill: '#232323'
    },
    {
      opacity: '.65',
      d:
        'M1321.91 551.83c.24-.48.74-1.44.98-1.92-.02.45-.08 1.36-.11 1.81l-.87.11Z',
      fill: '#353535'
    },
    {
      opacity: '.65',
      d: 'M601.19 573.87c1.13-.2 2.12.1 2.98.88-1.54.93-2.54.64-2.98-.88Z',
      fill: '#353535'
    },
    { opacity: '.59', d: 'M1045.27 551.23Z', fill: '#3a3a3a' },
    {
      opacity: '.84',
      d: 'M1064.04 551.7c.15-.16.46-.46.62-.62-.16.16-.47.46-.62.62Z',
      fill: '#3c3c3c'
    },
    {
      opacity: '.74',
      d:
        'm594.35 552.1.87-.13c-.27.49-.81 1.46-1.09 1.95.06-.45.17-1.37.22-1.82Z',
      fill: '#363636'
    },
    {
      opacity: '.82',
      d:
        'M623.95 556c.18-1.31 1.99-3.15 3.16-3.66.53 2.02-1.06 3.92-3.16 3.66Z',
      fill: '#242424'
    },
    {
      opacity: '.57',
      d: 'M1017.12 552.16c.15.14.45.43.61.57-.16-.14-.46-.43-.61-.57Z',
      fill: '#393939'
    },
    { opacity: '.57', d: 'm1036.3 571.28.59.63-.59-.63Z', fill: '#393939' },
    { opacity: '.58', d: 'm1047.15 552.25.77.32-.77-.32Z', fill: '#393939' },
    {
      opacity: '.68',
      d:
        'M1057.04 553.76c1.88-.83 3.87-1.38 5.9-1.8-.08 2.12-4.33 3.1-5.9 1.8Z',
      fill: '#282828'
    },
    {
      opacity: '.78',
      d:
        'M1289.84 554.71c1.66-1.03 3.42-1.87 5.21-2.67.36 2.18-3.53 4-5.21 2.67Z',
      fill: '#242424'
    },
    {
      opacity: '.68',
      d: 'M598.11 553.31c.18.09.55.27.73.36-.18-.09-.55-.27-.73-.36Z',
      fill: '#404040'
    },
    {
      opacity: '.58',
      d: 'M1049.07 552.91c1.1-.19 2.08.1 2.94.86-1.51.98-2.49.69-2.94-.86Z',
      fill: '#313131'
    },
    { opacity: '.75', d: 'M1274.25 553.2Z', fill: '#3f3f3f' },
    {
      opacity: '.59',
      d: 'M1321.29 553.74c.15-.16.47-.49.62-.65-.15.16-.47.49-.62.65Z',
      fill: '#3b3b3b'
    },
    {
      opacity: '.69',
      d: 'M600.12 554.31c.18.08.55.26.73.34-.18-.08-.55-.26-.73-.34Z',
      fill: '#404040'
    },
    {
      opacity: '.79',
      d:
        'M1018.33 553.56c1.07.54 1.66 1.42 1.77 2.62-1.56-.07-2.15-.95-1.77-2.62Z',
      fill: '#232323'
    },
    {
      opacity: '.6',
      d: 'm1276.06 553.94 1.92.92-.83.43-.97-.47-.12-.88Z',
      fill: '#343434'
    },
    { opacity: '.8', d: 'M602.16 555.25Z', fill: '#3f3f3f' },
    {
      opacity: '.62',
      d:
        'M1278.66 554.95c3.53.35 7.1.32 10.65-.01-3.08 1.88-6.91.85-10.31 1l-.34-.99Z',
      fill: '#343434'
    },
    {
      opacity: '.56',
      d: 'M1320.36 555.75c.07-.16.23-.48.3-.64-.07.16-.23.48-.3.64Z',
      fill: '#383838'
    },
    {
      opacity: '.76',
      d:
        'M603.99 556.13c.46.01 1.37.02 1.82.03l.11.85c-.49-.22-1.45-.66-1.93-.88Z',
      fill: '#373737'
    },
    {
      opacity: '.54',
      d: 'm621.32 556.21.93-.5.84.41c-.46.24-1.38.73-1.83.97l.06-.88Z',
      fill: '#2f2f2f'
    },
    {
      opacity: '.66',
      d: 'M646.82 558.8c-.21-1.14.12-2.1.99-2.89.86 1.53.53 2.49-.99 2.89Z',
      fill: '#303030'
    },
    {
      opacity: '.45',
      d:
        'M606.5 556.99c2.53-.25 5.01.35 7.5.72 2.24-.26 4.45-.99 6.74-.6-4.59 1.43-9.66 1.3-14.24-.12Z',
      fill: '#282828'
    },
    {
      opacity: '.85',
      d:
        'M1020.21 556.7c1.22.33 1.84 1.12 1.84 2.36-1.48.01-2.09-.78-1.84-2.36Z',
      fill: '#262626'
    },
    {
      opacity: '.77',
      d: 'M1087.95 559c-.08-1.3.54-2.06 1.84-2.27.18 1.54-.43 2.29-1.84 2.27Z',
      fill: '#262626'
    },
    {
      opacity: '.58',
      d: 'M646.31 560.65c.16-.16.46-.46.62-.61-.16.15-.46.45-.62.61Z',
      fill: '#3a3a3a'
    },
    {
      opacity: '.78',
      d:
        'M1022.78 560.52c2.21 1.51 4.13 3.4 5.65 5.62-2.39-1.24-4.32-3.31-5.65-5.62Z',
      fill: '#212121'
    },
    {
      opacity: '.89',
      d:
        'M1308.49 569.14c2.39-3.29 5.31-6.21 8.64-8.57-2.11 3.46-5.16 6.51-8.64 8.57Z',
      fill: '#1f1f1f'
    },
    {
      opacity: '.74',
      d: 'm128.55 562.53.09-.11c-.04.06-.13.18-.17.24l.08-.13Z',
      fill: '#a55f53'
    },
    {
      opacity: '.71',
      d:
        'm590.18 562.22.87-.12c-.23.49-.69 1.46-.92 1.94.02-.45.04-1.36.05-1.82Z',
      fill: '#353535'
    },
    {
      opacity: '.81',
      d:
        'M644.02 564.07c-.06-1.22.5-2.07 1.71-2.56.31 1.62-.26 2.47-1.71 2.56Z',
      fill: '#232323'
    },
    {
      opacity: '.76',
      d:
        'M638.47 570.02c1.67-2.02 3.53-3.88 5.56-5.53-1.01 2.46-3.14 4.45-5.56 5.53Z',
      fill: '#1f1f1f'
    },
    {
      opacity: '.86',
      d:
        'M1078.71 567.78c.31-1.26 1.08-1.87 2.33-1.83-.01 1.46-.78 2.08-2.33 1.83Z',
      fill: '#272727'
    },
    {
      opacity: '.71',
      d:
        'M592.1 570.84c-1.92.92-6.2-2.37-3.29-3.75.81 1.47 2.02 2.65 3.29 3.75Z',
      fill: '#2c2c2c'
    },
    {
      opacity: '.85',
      d:
        'M1029.92 566.96c1.22-.06 2.01.55 2.38 1.82-1.58.24-2.37-.37-2.38-1.82Z',
      fill: '#262626'
    },
    {
      opacity: '.8',
      d:
        'M1032.84 568.91c1.18.09 2.06.68 2.62 1.78-1.72.33-2.59-.26-2.62-1.78Z',
      fill: '#232323'
    },
    {
      opacity: '.8',
      d:
        'M635.56 571.73c.45-1.22 1.28-1.79 2.5-1.72-.06 1.45-.9 2.03-2.5 1.72Z',
      fill: '#242424'
    },
    {
      opacity: '.73',
      d:
        'M1302.62 572.86c.47-1.94 2.46-2.99 4.36-2.85-.05 1.61-2.94 2.61-4.36 2.85Z',
      fill: '#222'
    },
    {
      opacity: '.77',
      d: 'M1072.16 571.74c.19-.09.55-.27.74-.36-.19.09-.55.27-.74.36Z',
      fill: '#3f3f3f'
    },
    {
      opacity: '.72',
      d:
        'M595.11 571.95c.49.24 1.45.71 1.93.94-.46-.02-1.38-.07-1.84-.09l-.09-.85Z',
      fill: '#393939'
    },
    { opacity: '.65', d: 'M634.11 572.77Z', fill: '#3e3e3e' },
    {
      opacity: '.67',
      d: 'M1038.16 571.9c.48.25 1.43.75 1.91 1l-1.81-.12-.1-.88Z',
      fill: '#343434'
    },
    {
      opacity: '.77',
      d:
        'M1069.02 572.89c.47-.23 1.43-.71 1.91-.95l-.09.86c-.46.02-1.37.07-1.82.09Z',
      fill: '#353535'
    },
    {
      opacity: '.72',
      d:
        'M598.1 572.97c.5.22 1.48.68 1.98.9-.47-.01-1.4-.04-1.86-.06l-.12-.84Z',
      fill: '#3a3a3a'
    },
    {
      opacity: '.76',
      d:
        'M630.97 573.87c.49-.23 1.47-.69 1.95-.92l-.12.87c-.45.01-1.37.03-1.83.05Z',
      fill: '#353535'
    },
    { opacity: '.71', d: 'M1266.18 573.3Z', fill: '#3e3e3e' },
    {
      opacity: '.69',
      d:
        'M1297.71 574.94c.51-1.72 2.56-2.11 4.13-2.05-.04 1.54-2.83 2.25-4.13 2.05Z',
      fill: '#262626'
    },
    {
      opacity: '.82',
      d: 'M628.05 574.82c.54-.2 1.61-.58 2.14-.77l-.2.81-1.94-.04Z',
      fill: '#373737'
    },
    {
      opacity: '.71',
      d: 'M1044.14 573.88c1.14-.19 2.15.11 3.04.88-1.62.91-2.63.61-3.04-.88Z',
      fill: '#363636'
    },
    {
      opacity: '.7',
      d:
        'M1061.81 574.76c.87-.78 1.9-1.07 3.08-.88-.49 1.49-1.52 1.78-3.08.88Z',
      fill: '#383838'
    },
    {
      opacity: '.73',
      d:
        'M1268.1 573.95c.48.23 1.46.7 1.94.94-.45-.03-1.37-.07-1.83-.09l-.11-.85Z',
      fill: '#373737'
    },
    {
      opacity: '.72',
      d: 'M605.92 575.04c1.2-.31 2.32-.09 3.34.68-1.59.88-2.7.65-3.34-.68Z',
      fill: '#3b3b3b'
    },
    {
      opacity: '.76',
      d:
        'M622.94 575.76c1.11-.91 2.53-1.14 3.93-.84.02 1.67-2.93 1.61-3.93.84Z',
      fill: '#343434'
    },
    {
      opacity: '.55',
      d:
        'M1048.68 575.1c3.86-.15 7.73-.14 11.61-.03-3.55 1.4-8.1 1.54-11.61.03Z',
      fill: '#363636'
    },
    {
      opacity: '.74',
      d:
        'M1271.1 574.96c.48.23 1.45.7 1.94.93-.47-.02-1.39-.07-1.86-.09l-.08-.84Z',
      fill: '#3b3b3b'
    },
    {
      opacity: '.71',
      d: 'M1293.92 575.8c.79-.86 1.76-1.18 2.9-.95-.44 1.51-1.41 1.83-2.9.95Z',
      fill: '#313131'
    },
    {
      opacity: '.4',
      d:
        'M611.71 576.08c3.51-.01 7.03.03 10.55-.07-3.2 1.43-7.41 1.65-10.55.07Z',
      fill: '#2b2b2b'
    },
    {
      opacity: '.64',
      d: 'M1274.24 575.87c1.37-.21 2.81 0 3.98.88-1.06.84-3.98.79-3.98-.88Z',
      fill: '#343434'
    },
    {
      opacity: '.2',
      d: 'M1281.24 577.04c1.83-.1 3.69-.09 5.56 0-.62 1.81-5.03 1.85-5.56 0Z',
      fill: '#181818'
    },
    {
      opacity: '.82',
      d:
        'M389.77 644.01c.42-1.06 1.15-1.81 2.18-2.25.28 1.72-.45 2.47-2.18 2.25Z',
      fill: '#536798'
    }
  ]
}
